import React, { forwardRef, ForwardRefRenderFunction } from 'react';
import { Link as LinkMUI, LinkProps as LinkMUIProps } from '@mui/material';
import { useTranslation } from 'next-i18next';
import type { UrlObject } from 'url';
import { LinkProps as NextLinkProps } from 'next/link';
import NextLink from 'next-translate-routes/link'; // Note: /link, not /Link

export type TranslatedLinkProps = Omit<LinkMUIProps, 'href' | 'classes'> & {
    href: UrlObject | URL | string;
    locale?: string;
} & Pick<NextLinkProps, 'as' | 'prefetch' | 'locale'>;

export const TranslatedLink: ForwardRefRenderFunction<HTMLAnchorElement, TranslatedLinkProps> = (
    { href, as, prefetch, locale, ...props },
    ref
) => {
    const {i18n} = useTranslation();
    const targetLocale = locale || i18n.language;

    return (
        <LinkMUI
            component={NextLink}
            href={href}
            as={as}
            prefetch={prefetch}
            locale={targetLocale}
            ref={ref}
            {...props}
        >
            {props.children}
        </LinkMUI>
    )
};

export default forwardRef(TranslatedLink);
